import { apiGet, apiPost, apiPut, apiDelete, unwrap } from './apiClient';
import { ResponseDTO, CreatePolicyRequest, PolicyDetails, MdmPolicy } from '@/types/api';

const BASE = '/api/v1/apple/mdm/policies';

export async function createPolicy(request: CreatePolicyRequest): Promise<{ id: string }> {
  const res = await apiPost<ResponseDTO<{ id: string }>>(BASE, request);
  return unwrap(res);
}

export async function listPolicies(): Promise<PolicyDetails[]> {
  const res = await apiGet<ResponseDTO<PolicyDetails[]>>(BASE);
  return unwrap(res);
}

export async function getPolicy(id: string): Promise<PolicyDetails> {
  const res = await apiGet<ResponseDTO<PolicyDetails>>(`${BASE}/${id}`);
  return unwrap(res);
}

export async function updatePolicy(id: string, request: CreatePolicyRequest): Promise<string> {
  const res = await apiPut<ResponseDTO<null>>(`${BASE}/${id}`, request);
  return res.message || 'Policy updated';
}

export async function deletePolicy(id: string): Promise<string> {
  const res = await apiDelete<ResponseDTO<null>>(`${BASE}/${id}`);
  return res.message || 'Policy deleted';
}

export async function listCertificatePolicies(): Promise<MdmPolicy[]> {
  const res = await apiGet<ResponseDTO<MdmPolicy[]>>(`${BASE}/certificates`);
  return unwrap(res);
}

export async function getSubstitutionVariables(): Promise<string[]> {
  const res = await apiGet<ResponseDTO<string[]>>(`${BASE}/substitution-variables`);
  return unwrap(res);
}
